export default {
  id: 'what-is-algo-flows',
  title: 'What is Algo Flows?',
  content: `## What is Algo Flows?

Algo Flows is TradeLab's rule-based strategy automation engine. It lets you define a set of technical conditions and automatically places orders when those conditions are met — without you having to watch the screen.

---

## Where to Find It

**Profile → Algo Flows** or via the bottom navigation if pinned.

---

## What It Does

You define a strategy with:
- A list of NSE stocks to monitor
- A set of entry conditions (up to 12)
- A position size
- A cooldown period (prevents repeated re-entry)

The engine runs **every minute from 9:15 AM to 3:30 PM IST** on trading days. Each minute, it checks every active strategy against every symbol you have assigned to it. When all your conditions are met for a symbol, it automatically places a LIMIT order.

---

## How It Fits into Your Workflow

Algo Flows is not a replacement for judgment — it is a way to enforce rules you have already decided on.

**Example workflow:**
1. You observe that stocks breaking their 20-day high with RSI between 50–65 tend to follow through
2. You create an Algo Flow strategy with those two conditions
3. The engine monitors all 50+ stocks and fires when both conditions are met simultaneously
4. You review the triggered order, decide whether to let it stand or cancel it

---

## What Algo Flows Is Not

- It is **not** a fully autonomous trading robot — orders it creates can be reviewed and cancelled
- It is **not** a backtesting tool — it runs on current market data, not historical
- It is **not** a guaranteed edge — the conditions you define determine the quality

---

## Order Source Tagging

All orders placed by Algo Flows are tagged with source: **ALGO_FLOW**. This lets you compare the performance of automated strategy orders against your MANUAL trades and NYX_AI orders in Trade History and Trade Analysis.

---

## Strategy Lifecycle

| State | What it means |
|---|---|
| ACTIVE | Engine is evaluating this strategy every minute |
| PAUSED | Strategy exists but the engine skips it |
| DRAFT | Strategy saved but not yet activated |

You can pause, resume, or delete strategies at any time from the Algo Flows screen.`,
};
